module.exports = __webpack_public_path__ + "static/media/house_alt.7c9425aa.jpg";